/* cords2-office.js - the Business page's shop: cards, kits, filter, VAT
   toggle and the summary bar. 19 October 2026.

   Every price is worked out here from the variant's own price, which the
   store holds INCLUDING VAT. Ex VAT is that price over (1 + the visitor's
   VAT rate), the rate read from the section's country map. The tier prices
   are the same price less the tier's percentage: they are what the page
   promises, and the automatic discounts in the admin are what makes the cart
   keep the promise. If the two ever disagree, the cart is right, which is
   why the bar reads its totals and savings from /cart.js, never from here.

   A tier percentage of 0 means the tier is not set yet, and its price shows
   an en dash, the house placeholder for a value not stated. */
(function () {
  var root = document.querySelector('[data-c2-os]');
  var kitsRoot = document.querySelector('[data-c2-kits]');
  if (!root && !kitsRoot) return;
  var cfg = root || kitsRoot;

  var T1 = parseFloat(cfg.getAttribute('data-t1')) || 0;
  var T2 = parseFloat(cfg.getAttribute('data-t2')) || 0;
  var SCOPE = cfg.getAttribute('data-scope') || 'order';
  var RATE = (function () {
    var c = (window.Shopify && Shopify.country) || cfg.getAttribute('data-country') || '';
    var map = (cfg.getAttribute('data-vat') || '').split(',');
    for (var i = 0; i < map.length; i++) {
      var kv = map[i].split(':');
      if (kv[0] && kv[0].trim() === c) return parseFloat(kv[1]) / 100;
    }
    return parseFloat(cfg.getAttribute('data-vat-default') || '25') / 100;
  })();
  var FMT = (window.theme && theme.moneyFormat) || '{{amount}}';
  var KEY = 'c2-vat';
  var ex = true;
  try { ex = localStorage.getItem(KEY) !== 'in'; } catch (e) {}

  function money(cents) {
    cents = Math.round(cents);
    var m = FMT.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = m ? m[1] : 'amount';
    function group(n, d, t, s) {
      var p = (n / 100).toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      var out = p.length > 1 ? p[0] + s + p[1] : p[0];
      return out.replace(new RegExp('\\' + s + '00$'), '');
    }
    var v;
    if (kind === 'amount_no_decimals') v = group(cents, 0, ',', '.');
    else if (kind === 'amount_with_comma_separator') v = group(cents, 2, '.', ',');
    else if (kind === 'amount_no_decimals_with_comma_separator') v = group(cents, 0, '.', ',');
    else if (kind === 'amount_with_space_separator') v = group(cents, 2, ' ', ',');
    else if (kind === 'amount_no_decimals_with_space_separator') v = group(cents, 0, ' ', ',');
    else if (kind === 'amount_with_apostrophe_separator') v = group(cents, 2, "'", '.');
    else v = group(cents, 2, ',', '.');
    return FMT.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  }
  function shown(incl) { return ex ? incl / (1 + RATE) : incl; }
  function tierPct(n) { return n >= 50 ? T2 : (n >= 10 ? T1 : 0); }
  function publish(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }

  /* ---------- the summary bar and the bag count ---------- */
  var bar = document.querySelector('[data-c2-osbar]');
  function bag(n) {
    document.querySelectorAll('.cords2-header__bag').forEach(function (a) {
      var c = a.querySelector('.cords2-header__count');
      if (n > 0) {
        if (!c) { c = document.createElement('span'); c.className = 'cords2-header__count'; c.setAttribute('aria-hidden', 'true'); a.appendChild(c); }
        c.textContent = n;
      } else if (c) { c.remove(); }
      var h = a.querySelector('.visually-hidden');
      if (h) h.textContent = h.textContent.replace(/\d+\s*$/, n);
    });
  }
  function refresh() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        bag(cart.item_count);
        if (!bar) return cart;
        if (!cart.item_count) { bar.hidden = true; return cart; }
        bar.hidden = false;
        bar.querySelector('[data-units]').textContent = cart.item_count;
        bar.querySelector('[data-total]').textContent = money(shown(cart.total_price));
        bar.querySelector('[data-vatword]').textContent = ex ? bar.getAttribute('data-ex') : bar.getAttribute('data-in');
        var save = bar.querySelector('[data-save]');
        save.hidden = !cart.total_discount;
        save.querySelector('span').textContent = money(shown(cart.total_discount));
        return cart;
      }).catch(function () {});
  }
  function add(items, done) {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) { refresh(); done(res.ok, res.j); })
      .catch(function () { done(false, {}); });
  }

  /* ---------- a product card ---------- */
  function card(el) {
    var vs = JSON.parse(el.querySelector('[data-v]').textContent);
    var shot = el.querySelector('.c2-os__media img');
    var qty = el.querySelector('input[type=number]');
    var btn = el.querySelector('[data-add]');
    var msg = el.querySelector('[data-msg]');
    var o1El = el.querySelector('[data-o1][aria-pressed=true]');
    var o1 = o1El ? o1El.getAttribute('data-o1') : null;
    var o2El = el.querySelector('[data-o2][aria-pressed=true]');
    var o2 = o2El ? o2El.getAttribute('data-o2') : null;

    function current() {
      for (var i = 0; i < vs.length; i++) {
        if ((!o1 || vs[i].o1 === o1) && (!o2 || vs[i].o2 === o2)) return vs[i];
      }
      return vs[0];
    }
    function paint() {
      var v = current();
      var n = Math.max(1, parseInt(qty.value, 10) || 1);
      el.querySelectorAll('[data-tier]').forEach(function (t) {
        var k = parseInt(t.getAttribute('data-tier'), 10);
        var pct = k === 0 ? 0 : (k === 1 ? T1 : T2);
        t.textContent = (k > 0 && !pct) ? '–' : money(shown(v.p * (1 - pct / 100)));
      });
      el.querySelectorAll('[data-tierrow]').forEach(function (r) {
        var k = parseInt(r.getAttribute('data-tierrow'), 10);
        var on = (k === 0 && n < 10) || (k === 1 && n >= 10 && n < 50) || (k === 2 && n >= 50);
        if (on) r.setAttribute('data-on', ''); else r.removeAttribute('data-on');
      });
      var line = el.querySelector('[data-line]');
      if (line) line.textContent = money(shown(v.p * n * (1 - (SCOPE === 'product' ? tierPct(n) : 0) / 100)));
      if (shot && v.img && shot.getAttribute('src') !== v.img) { shot.setAttribute('srcset', ''); shot.setAttribute('src', v.img); }
      btn.disabled = !v.a;
      btn.textContent = v.a ? btn.getAttribute('data-label') : btn.getAttribute('data-sold');
    }
    el.querySelectorAll('[data-o1]').forEach(function (b) {
      b.addEventListener('click', function () {
        el.querySelectorAll('[data-o1]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true'); o1 = b.getAttribute('data-o1');
        var nm = el.querySelector('[data-finish]'); if (nm) nm.textContent = o1;
        paint();
      });
    });
    el.querySelectorAll('[data-o2]').forEach(function (b) {
      b.addEventListener('click', function () {
        el.querySelectorAll('[data-o2]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true'); o2 = b.getAttribute('data-o2'); paint();
      });
    });
    el.querySelectorAll('[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10));
        paint();
      });
    });
    qty.addEventListener('input', paint);
    btn.addEventListener('click', function () {
      var v = current();
      var n = Math.max(1, parseInt(qty.value, 10) || 1);
      btn.disabled = true;
      add([{ id: v.id, quantity: n }], function (ok, j) {
        btn.disabled = false;
        msg.textContent = ok ? msg.getAttribute('data-ok').replace('[n]', n) : (j.description || msg.getAttribute('data-err'));
        if (ok) { btn.textContent = btn.getAttribute('data-added'); setTimeout(paint, 2400); }
        publish('cords:office_add', { variant: v.id, quantity: n, product: el.getAttribute('data-handle') });
      });
    });
    el._paint = paint;
    paint();
  }

  /* ---------- a kit ----------
     Each line can take its own color (28 October 2026): a line's chips set
     line.f, and the kit's chips set every line at once. A line with no color
     of its own follows the kit's. */
  function kit(el) {
    var lines = JSON.parse(el.querySelector('[data-k]').textContent);
    var finish = (el.querySelector('[data-kf][aria-pressed=true]') || el.querySelector('[data-kf]'));
    var f = finish ? finish.getAttribute('data-kf') : null;
    var btn = el.querySelector('[data-kadd]');
    var msg = el.querySelector('[data-msg]');
    function pick(line) {
      var want = line.f || f;
      var best = null;
      for (var i = 0; i < line.v.length; i++) {
        if (!want || line.v[i].o1 === want) { best = line.v[i]; break; }
      }
      return best || line.v[0];
    }
    function rowPaint() {
      el.querySelectorAll('[data-krow]').forEach(function (row) {
        var l = lines[parseInt(row.getAttribute('data-krow'), 10)];
        var want = l ? (l.f || f) : f;
        row.querySelectorAll('[data-rf]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-rf') === want ? 'true' : 'false'); });
      });
    }
    el.querySelectorAll('[data-krow]').forEach(function (row) {
      var l = lines[parseInt(row.getAttribute('data-krow'), 10)];
      row.querySelectorAll('[data-rf]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (l) l.f = b.getAttribute('data-rf');
          rowPaint(); paint();
        });
      });
    });
    /* A set keeps its set price: it gets no tier and does not count toward
       one (28 October 2026, as the automatic discounts are set up). */
    function paint() {
      var units = 0, tierUnits = 0, sum = 0;
      lines.forEach(function (l) { units += l.q; if (!l.s) tierUnits += l.q; });
      lines.forEach(function (l) {
        var v = pick(l);
        var pct = l.s ? 0 : (SCOPE === 'product' ? tierPct(l.q) : tierPct(tierUnits));
        sum += v.p * l.q * (1 - pct / 100);
      });
      el.querySelector('[data-ktotal]').textContent = money(shown(sum));
      el.querySelector('[data-kunits]').textContent = units;
    }
    el.querySelectorAll('[data-kf]').forEach(function (b) {
      b.addEventListener('click', function () {
        el.querySelectorAll('[data-kf]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true'); f = b.getAttribute('data-kf');
        var nm = el.querySelector('[data-finish]'); if (nm) nm.textContent = f;
        lines.forEach(function (l) { l.f = null; });
        rowPaint(); paint();
      });
    });
    btn.addEventListener('click', function () {
      var items = lines.map(function (l) { return { id: pick(l).id, quantity: l.q }; });
      btn.disabled = true;
      add(items, function (ok, j) {
        btn.disabled = false;
        msg.textContent = ok ? msg.getAttribute('data-ok') : (j.description || msg.getAttribute('data-err'));
        publish('cords:kit_add', { kit: el.getAttribute('data-name'), finish: f, items: items });
      });
    });
    el._paint = paint;
    rowPaint();
    paint();
  }

  /* ---------- the filter, from the row and from the space tiles ---------- */
  function filter(key) {
    if (!root) return;
    root.querySelectorAll('[data-f]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-f') === key ? 'true' : 'false'); });
    root.querySelectorAll('[data-spaces]').forEach(function (c) {
      c.hidden = !(key === 'all' || (' ' + c.getAttribute('data-spaces') + ' ').indexOf(' ' + key + ' ') > -1);
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-c2-filter]');
    if (!t || !root) return;
    e.preventDefault();
    filter(t.getAttribute('data-c2-filter'));
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  if (root) root.querySelectorAll('[data-f]').forEach(function (b) {
    b.addEventListener('click', function () { filter(b.getAttribute('data-f')); });
  });

  /* ---------- the VAT toggle ---------- */
  function vat() {
    document.querySelectorAll('[data-vatbtn]').forEach(function (b) {
      b.setAttribute('aria-pressed', (b.getAttribute('data-vatbtn') === 'ex') === ex ? 'true' : 'false');
    });
    document.querySelectorAll('[data-vatnote]').forEach(function (n) {
      n.textContent = ex ? n.getAttribute('data-ex') : n.getAttribute('data-in');
    });
    document.querySelectorAll('[data-c2-oscard],[data-c2-kit]').forEach(function (c) { if (c._paint) c._paint(); });
    refresh();
  }
  document.querySelectorAll('[data-vatbtn]').forEach(function (b) {
    b.addEventListener('click', function () {
      ex = b.getAttribute('data-vatbtn') === 'ex';
      try { localStorage.setItem(KEY, ex ? 'ex' : 'in'); } catch (e) {}
      vat();
    });
  });

  /* The larger-orders form posts natively; this only reports that it did. */
  document.querySelectorAll('#c2-enquiry').forEach(function (f) {
    f.addEventListener('submit', function () {
      var u = f.querySelector('[name="contact[Units]"]');
      publish('cords:enquiry_submit', { units: u ? u.value : '' });
    });
  });

  document.querySelectorAll('[data-c2-oscard]').forEach(card);
  document.querySelectorAll('[data-c2-kit]').forEach(kit);
  vat();
})();
